import axios from 'axios';
import {environment} from "../utils/environment";

const Api = axios.create({
    baseURL: environment.apiUrl,
    headers: {
        'Cache-Control': 'no-cache',
        Accept: 'application/json; version=0',
        'Content-Type': 'application/json; charset=utf-8',
    },
    timeout: 50000,
});
Api.interceptors.request.use(
    async config => {
       return {
            ...config,
            headers: {
                ...config.headers,
                authorization: `Bearer ${environment.token}`,
            },
        };
    },
    error => Promise.reject(error),
);
// httpClient.interceptors.response.use(function(request) {
//   console.log(' interceptors response ', request);
// });
export default Api;
